module.exports = __webpack_public_path__ + "img/Logo_MOK.63fe7940.webp";